import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts, PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { ScopeApplicationSummary } from "../../domain/ScopeApplication";

export class ScopeExpansionService extends BaseRemoteService {
  public async search(id: string, params: QueryParams = {}, opts: Opts): Promise<PagedResponse<ScopeApplicationSummary>> {
    const url = `${this.apiRoot}/api/organisations/${id}/expansionapplicationsummary/${paramsToSearchString(params)}`;
    return await super.getRequest<PagedResponse<ScopeApplicationSummary>>(url, opts);
  }
}